/**
 * A portaria da sala (SPEC-20260917-0047).
 *
 * Quem abriu a sala decide quem entra. O cartão aparece nos DOIS lugares onde a
 * pessoa pode estar quando alguém bate na porta: na antessala (o link costuma
 * ser enviado antes de discar) e dentro da chamada.
 *
 * Nome e recado são texto digitado por alguém sem conta — servem para o dono
 * reconhecer a pessoa, nunca como identidade verificada. Por isso o cartão diz
 * de onde vem ("pelo link") em vez de tratar como membro.
 */
export type PedidoNaPorta = { guestId: string; visitante: string; recado: string | null }

export function Portaria({
  pedidos,
  onDecidir,
}: {
  pedidos: PedidoNaPorta[]
  onDecidir: (guestId: string, aprovar: boolean) => void
}) {
  if (pedidos.length === 0) return null

  return (
    <div className="vc-porta" role="alertdialog" aria-label="Alguém quer entrar na chamada">
      {pedidos.map((pedido) => (
        <div className="vc-porta__cartao" key={pedido.guestId}>
          <span className="vc-porta__avatar" aria-hidden>
            <i className="fas fa-user" />
          </span>
          <span className="vc-porta__texto">
            <span className="vc-porta__nome">{pedido.visitante}</span>
            <span className="vc-porta__sub">{pedido.recado || 'quer entrar pelo link'}</span>
          </span>
          <span className="vc-porta__acoes">
            <button
              type="button"
              className="vc-botao vc-botao--recusar"
              onClick={() => onDecidir(pedido.guestId, false)}
            >
              <i className="fas fa-times" aria-hidden />
              <span>Barrar</span>
            </button>
            <button
              type="button"
              className="vc-botao vc-botao--aceitar"
              onClick={() => onDecidir(pedido.guestId, true)}
            >
              <i className="fas fa-check" aria-hidden />
              <span>Deixar entrar</span>
            </button>
          </span>
        </div>
      ))}
    </div>
  )
}
